module.exports = __webpack_public_path__ + "img/logout-es.c25f3951.png";